import { render } from "./ModalPayment.vue?vue&type=template&id=b3c212f4&scoped=true"
import script from "./ModalPayment.vue?vue&type=script&lang=js"
export * from "./ModalPayment.vue?vue&type=script&lang=js"

import "./styles/ModalPayment.scss?vue&type=style&index=0&id=b3c212f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c212f4"]])

export default __exports__